var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.inputComponentType,{tag:"component",staticClass:"text-right",attrs:{"autofocus":"","value":_vm.value,"hide-details":"","no-prefix":true,"dense":false,"outlined":false},on:{"input":_vm.onValueChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }